import Vue from 'vue';
import VueI18n from 'vue-i18n/dist/vue-i18n.esm';

import App from './App.vue';
import router from './router';

import './styles/index.scss';

import './plugins/webuniversum';
import './plugins/wse-forms';

Vue.config.productionTip = false;

const i18n = new VueI18n({
  fallbackLocale: 'nl'
});

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');
